// src/merch/PrivacyPage.jsx
//
// /privacy — renders src/merch/privacy.md (the same file goes to the
// lawyer, so the live page and the reviewed text can't drift apart).
// Tiny markdown renderer: # / ## headings, paragraphs, "- " lists,
// **bold**, _italic_, [links](url).

import { StoreLogo } from "./StoreBrand.jsx";
import React from "react";
import md from "./privacy.md?raw";

function inline(text, keyBase) {
  const out = [];
  const re = /\*\*(.+?)\*\*|_(.+?)_|\[(.+?)\]\((https?:\/\/[^)]+)\)/g;
  let last = 0, m, k = 0;
  while ((m = re.exec(text))) {
    if (m.index > last) out.push(text.slice(last, m.index));
    if (m[1]) out.push(<b key={`${keyBase}-${k++}`}>{m[1]}</b>);
    else if (m[2]) out.push(<em key={`${keyBase}-${k++}`}>{m[2]}</em>);
    else out.push(<a key={`${keyBase}-${k++}`} href={m[4]} target="_blank" rel="noreferrer">{m[3]}</a>);
    last = re.lastIndex;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}

function render(src) {
  const blocks = src.replace(/\r/g, "").split(/\n{2,}/);
  return blocks.map((b, i) => {
    const t = b.trim();
    if (!t) return null;
    if (t.startsWith("## ")) return <h2 key={i}>{inline(t.slice(3), i)}</h2>;
    if (t.startsWith("# ")) return <h1 key={i}>{inline(t.slice(2), i)}</h1>;
    const lines = t.split("\n");
    if (lines.every((l) => l.startsWith("- "))) {
      return <ul key={i}>{lines.map((l, j) => <li key={j}>{inline(l.slice(2), `${i}-${j}`)}</li>)}</ul>;
    }
    return <p key={i}>{inline(lines.join(" "), i)}</p>;
  });
}

export default function PrivacyPage({ homeHref }) {
  return (
    <div className="ma-app">
      <header className="ma-header">
        <StoreLogo link={homeHref} />
        <div className="ma-sub">Privacy</div>
      </header>
      <main className="ma-legal">{render(md)}</main>
    </div>
  );
}
